import { gql } from 'apollo-boost';

export const CREATE_API_TOKEN = gql`
    mutation CreateApiToken($data: CreateApiTokenInput!) {
        createApiToken(data: $data) {
            token
            apiToken {
                id
                name
                prefix
                scopes
                createdAt
                lastUsedAt
                expiresAt
            }
        }
    }
`;
